export enum RecordType {
  'map' = 'map',
  'measurement' = 'measurement',
  'station' = 'station',
  'unknown' = 'unknown',
  'vessel' = 'vessel',
  'geologicalSample' = 'geologicalSample',
}

export interface Record {
  id: string;
  datasetId: string;
  parentId: string;
  type: string;
  content: { [key: string]: unknown; values: []; coordinates: [] | undefined };

  created: Date;
  createdBy: string;
  modified: Date;
  modifiedBy: string;
}
